module.exports = __webpack_public_path__ + "static/img/Tela de estoque.bff4778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de estoque.png
// module id = jXxq
// module chunks = 0